import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { UserModalModel } from 'src/lib/services/api/users/modals/user-modal.model';
import { PromptAgreementsModalComponent } from './prompt-agreements-modal.component';

@Injectable({
	providedIn: 'root',
})
export class PromptAgreementsModalService {
	constructor(private modalService: NgbModal) {}

	public openModal$(data?: UserModalModel) {
		return new Observable<boolean>((o) => {
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				scrollable: true,
				windowClass: 'modal-info',
			};
			const modal = this.modalService.open(
				PromptAgreementsModalComponent,
				ngbModalOptions,
			);

			(modal.componentInstance as PromptAgreementsModalComponent).bindModalData(
				{
					data: data,
				},
			);

			modal.result
				.then(() => {
					o.next(true);
					o.complete();
				})
				.catch(() => {
					o.next(false);
					o.complete();
				});
		});
	}
}
